module.exports = __webpack_public_path__ + "static/media/slideshow-17.d0a07ea8.jpeg";